import { Box } from '@mui/material'
import { 
  CheckCircle, 
  Error, 
  Warning, 
  Build, 
  Pause 
} from '@mui/icons-material'
import { alpha } from '@mui/material/styles'

const MonitorStatus = ({ sx = {}, status, iconSize = 16 }) => {
  const statusConfig = {
    up: {
      color: '#10b981',
      pulseColor: alpha('#10b981', 0.4),
      icon: CheckCircle,
      label: 'Aktif',
    },
    down: {
      color: '#ef4444',
      pulseColor: alpha('#ef4444', 0.4),
      icon: Error,
      label: 'Hata',
    },
    uncertain: {
      color: '#f59e0b',
      pulseColor: alpha('#f59e0b', 0.4),
      icon: Warning,
      label: 'Belirsiz',
    },
    maintenance: {
      color: '#6366f1',
      pulseColor: alpha('#6366f1', 0.4),
      icon: Build,
      label: 'Bakım',
    },
    paused: {
      color: '#64748b',
      pulseColor: alpha('#64748b', 0.4),
      icon: Pause,
      label: 'Durduruldu',
    },
  }

  const config = statusConfig[status] || statusConfig.uncertain
  const Icon = config.icon

  const width = sx.width || 16
  const height = sx.height || 16
  const animeWidth = sx.animeWidth || 12
  const animeHeight = sx.animeHeight || 12

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
      }}
    >
      {/* Pulse Animation */}
      <Box
        sx={{
          position: 'absolute',
          width: animeWidth,
          height: animeHeight,
          borderRadius: '50%',
          bgcolor: config.pulseColor,
          animation: 'pulseAnimation 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
          '@keyframes pulseAnimation': {
            '0%, 100%': {
              transform: 'scale(1)',
              opacity: 1,
            },
            '50%': {
              transform: 'scale(2.5)',
              opacity: 0,
            },
          },
        }}
      />

      {/* Status Indicator */}
      <Box
        sx={{
          width,
          height,
          borderRadius: '50%',
          bgcolor: config.color,
          border: `2px solid ${alpha('#fff', 0.9)}`,
          boxShadow: `0 0 12px ${alpha(config.color, 0.6)}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          zIndex: 1,
          transition: 'all 0.3s ease',
        }}
      >
        <Icon
          sx={{
            fontSize: iconSize,
            color: '#fff',
          }}
        />
      </Box>
    </Box>
  )
}

export default MonitorStatus